/**
 * AppLaunch — the PWA start_url landing shim.
 *
 * Manifest.json points `start_url` at `/app`, so tapping the installed
 * home-screen icon lands here instead of the public marketing homepage.
 * We then redirect based on auth state:
 *
 *   • Authed owner  → /app/dashboard
 *   • Authed staff  → /app/my-training
 *   • Unauthed      → /app/login
 *
 * Deep links (e.g. /verify/:certId, /app/dashboard opened from a
 * notification) bypass this shim entirely because the router matches
 * their exact path first.
 */

import { Navigate } from "react-router-dom";
import { useAuth, roleHome } from "../AuthContext";

export default function AppLaunch() {
  const { status, user } = useAuth();

  // Prevent a marketing-page flash while /auth/me is in flight. Matches
  // the deep-navy brand background so the transition feels native.
  if (status === "checking") {
    return (
      <div
        data-testid="app-launch-splash"
        style={{
          minHeight: "100vh",
          background: "#040914",
        }}
        aria-hidden="true"
      />
    );
  }

  if (status === "authed") {
    return <Navigate to={roleHome(user)} replace />;
  }

  return <Navigate to="/app/login" replace />;
}
